import React, { useRef, useEffect, useCallback } from "react";
import { CTA_TYPE } from "../../../../../shared/utils/omni-utils";
import { VALID_NAME_ERROR, MOB_CABS_REVIEW, TRAVELLER_DETAILS_UI, CABS_REVIEW_ROUTE, VALID_PH_NUM_ERROR, VALID_EMAIL_ERROR } from "../../../../../shared/utils/util-constants";
import { ErrorInfo, pushCtaOmniEvents } from "../../../../../shared//config/omni";
import InputField from "../../../../../stories/core-components/InputFeild/InputFeildUI";
import * as S from "./TravellerDetails.styles";
import { DEFAULT_CONTACT_DETAILS } from "../../../../../../src/shared/config/constants";

interface ITravellerDetails {
  onUpdateTravellerDetails: Function;
  travellerDetails: {};
  travellerTitle: Array<any>;
  error: {};
}

const TravellerDetailsUI: React.FC<ITravellerDetails> = ({
  onUpdateTravellerDetails = () => {},
  travellerDetails = {},
  travellerTitle = DEFAULT_CONTACT_DETAILS,
  error = {}
}) => {
  const nameRef = useRef();
  const emailRef = useRef();
  const mobileRef = useRef();
  const {
    phone_number = "",
    email = "",
    first_name = "",
    gender = ""
  } = travellerDetails;

  useEffect(() => {
    nameRef.current.value = first_name;
    emailRef.current.value = email;
    mobileRef.current.value = phone_number;
  }, [travellerDetails]);

  useEffect(() => {
    const errorInfo : ErrorInfo[] = []
    if (error?.['first_name']?.error) {
      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${VALID_NAME_ERROR}`, CTA_TYPE.HYPER_LINK, TRAVELLER_DETAILS_UI, CABS_REVIEW_ROUTE)
      errorInfo.push({field: 'firstName', message : 'Please enter valid name'})
    }

    if (error?.['phone_number']?.error) {
      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${VALID_PH_NUM_ERROR}`, CTA_TYPE.HYPER_LINK, TRAVELLER_DETAILS_UI, CABS_REVIEW_ROUTE)
      errorInfo.push({field: 'phone_number', message : 'Please enter valid mobile number'})
    }

    if (error?.['email']?.error) {
      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${VALID_EMAIL_ERROR}`, CTA_TYPE.HYPER_LINK, TRAVELLER_DETAILS_UI, CABS_REVIEW_ROUTE)
      errorInfo.push({field: 'email', message : 'Please enter valid email'})
    }
  }, [error])

  const handleChange = useCallback(
    ({ type, value }) => {
      onUpdateTravellerDetails({ ...travellerDetails, [type]: value });
    },
    [onUpdateTravellerDetails, travellerDetails],
  );
  return (
    <S.TravellerCont>
      <div className="fieldRow">
        <div className="makeFlex">
          <div style={{ flexDirection: "row" }}>
            <p className="labelText">Gender</p>
            <S.GenderWidget>
              <label htmlFor="Select Gender">
                <select name="" id="gender" onChange={(e) => onUpdateTravellerDetails({ gender: e.currentTarget.value})}>
                  {
                    travellerTitle.map(element => 
                       <option value={element?.value} selected={gender === element?.value}>{element?.title}</option>
                    )
                  }
                  {/* <option value="Mr" selected={gender === 'Mr'}>Mr</option>
                  <option value="Mrs" selected={gender === 'Mrs'}>Mrs</option>
                  <option value="Miss" selected={gender === 'Miss'}>Miss</option> */}
                </select>
              </label>
            </S.GenderWidget>
          </div>
          <div>
            <InputField
              styledProps={error?.['first_name']?.error ? {border: 'solid 1px #ff3a5c'} : {}}
              labelText="Name"
              reference={nameRef}
              placeholderText="Enter Full Name"
              inputType="text"
              onChange={(e) =>
                handleChange({ type: "first_name", value: e.target.value })
              }
              inputWidth={'27rem'}
            />
            {error?.['first_name']?.error ? <S.ErrorToastTxt>Please enter valid name</S.ErrorToastTxt> : null}
          </div>
        </div>
      </div>
      <div className="fieldRow">
        <p className="labelText">Mobile Number</p>
        <div className="makeFlex">
          <div className="guestDtls__contact">
            <label htmlFor="countryCode" className="frmSelectCont__contact">
              <select name="" id="countryCode" className="frmSelect">
                <option value="+91">+91</option>
              </select>
            </label>
            <span className="selectedCode">{+91}</span>
          </div>
          <div>
            <InputField
              styledProps={error?.['phone_number']?.error ? {border: 'solid 1px #ff3a5c'} : {}}
              placeholderText="Enter Mobile Number"
              inputType="text"
              reference={mobileRef}
              onChange={(e) => {
                handleChange({ type: "phone_number", value: e.target.value });
              }}
              inputWidth={'27rem'}
            />
            {error?.['phone_number']?.error ? <S.ErrorToastTxt>Please enter valid mobile number</S.ErrorToastTxt> : null}
          </div>
        </div>
      </div>
      <div className="fieldRow">
        <InputField
          styledProps={error?.['email']?.error ? {border: 'solid 1px #ff3a5c'} : {}}
          labelText="Email"
          reference={emailRef}
          subLabelText="(Your E-ticket and updates will be sent here)"
          placeholderText="Enter Email"
          inputType="email"
          onChange={(e) => handleChange({ type: "email", value: e.target.value })}
          inputWidth={'30rem'}
        />
        {error?.['email']?.error ? <S.ErrorToastTxt>Please enter valid email</S.ErrorToastTxt> : null}
      </div>
    </S.TravellerCont>
  );
};

export default React.memo(TravellerDetailsUI);
